import { memo, useEffect, useState } from "react";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const Devtools = memo(() => {
  const [showDevtools, setShowDevtools] = useState(import.meta.env.DEV);

  useEffect(() => {
    // @ts-expect-error — toggleDevtools нет в типах window, вешаем хелпер для ручного переключения из консоли
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  if (!showDevtools) {
    return null;
  }

  return (
    <>
      <ReactQueryDevtools position="bottom" initialIsOpen={false} />
      <TanStackRouterDevtools position="bottom-right" initialIsOpen={false} />
    </>
  );
});
